module.exports = __webpack_public_path__ + "static/media/stars-less-1366.a2efe954.jpg";